'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

interface ErrorInfo {
  type: string
  message: string
}

interface ErrorContextType {
  error: ErrorInfo | null
  setError: (error: ErrorInfo | null) => void
}

const ErrorContext = createContext<ErrorContextType>({
  error: null,
  setError: () => {},
})

export function ErrorProvider({ children }: { children: ReactNode }) {
  const [error, setError] = useState<ErrorInfo | null>(null)
  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {children}
    </ErrorContext.Provider>
  )
}

export function useError() {
  return useContext(ErrorContext)
}
